import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class CalendarioComponent {
  @Input() public titulo = '';
  @Input() public diasDaSemana: string[] = [];
  @Output() public mudarMes = new EventEmitter<number>();
}
